import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from "@mui/material";

export default function DialogConfirmCondicoes({
    open,
    handleClose,
    handleConfirmChange
}: DialogConfirmCondicoesProps) {	
  return (
    <Dialog
    open={open}
    onClose={handleClose}
>
    <DialogTitle>Confirmação</DialogTitle>
    <DialogContent>
        <DialogContentText>
        Esta ação limpará os valores de recebimento adicionados.
        </DialogContentText>
        <DialogContentText>
            Deseja realmente mudar a condição?
        </DialogContentText>
    </DialogContent>
    <DialogActions>
        <Button onClick={handleClose} color="primary">
            Cancelar
        </Button>
        <Button onClick={handleConfirmChange} color="error" autoFocus>
            Confirmar
        </Button>
    </DialogActions>
</Dialog>
  )
}

interface DialogConfirmCondicoesProps {
  open: boolean;
  handleClose: () => void;
  handleConfirmChange: () => void;
}